import styled from "styled-components";

export const CheckBox = styled.div`
    width:20px;
    height:20px;
    min-width: 20px;
    display: flex;
    justify-content:center;
    align-items:center;
    cursor: pointer;
    border:${props=> props.selected ? props.theme.border.small_red2 : props.theme.border.small };
    border-radius: 4px;
`;